export const staircaseConfig = {
    gameSlug: 'logic-trail',
    category: 'foudre_logique',
    variable: 'n_items',
    startValue: 8,
    minValue: 5,
    maxValue: 25,
    stepSizesByPhase: [3, 2, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 16,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, mode: 'A', deadlineMs: 60000, dispersion: 0.65, label: 'TMT-A initiation' };
    }
    if (level <= 20) {
        return { level, mode: 'A', deadlineMs: 45000, dispersion: 0.80, label: 'TMT-A vif' };
    }
    if (level <= 30) {
        return { level, mode: 'B', deadlineMs: 60000, dispersion: 0.80, label: 'TMT-B alternance' };
    }
    if (level <= 40) {
        return { level, mode: 'C', deadlineMs: 60000, dispersion: 0.85, label: '3-way alternance' };
    }
    return { level, mode: 'C', deadlineMs: 45000, dispersion: 0.90, label: 'Limite executive' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durees non-staircase. */
export const timing = {
    fixationMs: 400,
    feedbackMs: 800,
    itiMs: 700,
};
export const paradigmMeta = {
    slug: 'logic-trail',
    paradigm: 'Trail Making Test (Reitan 1958)',
    masterMage: 'Volta (foudre-logique)',
    category: 'foudre_logique',
    goal: "Set-shifting + vitesse executive : conduite, gestion taches multiples, decisions sequentielles.",
};
//# sourceMappingURL=params.js.map